module.exports = __webpack_public_path__ + "img/3598130.792a6ef7.jpg";